module.exports = __webpack_public_path__ + "static/media/Shadow_Stories.c1db4861.png";